import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './termKeyword.css';

export default class TermKeyword extends Component {

    render() {
      return (<div className='term-keyword'>
        <p className='term-keyword__keyword'>&ldquo;{this.props.keyword}&rdquo;</p>
        <p>has</p>
      </div>);
    }
}

TermKeyword.propTypes = {
  keyword: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/term-keyword/termKeyword.js